export const colors = [
    '#33ddff', '#fa3253', '#34d1b7', '#ff007c', '#ff6037', '#ddff33',
    '#24b353', '#b83df5', '#66ff66', '#32b7fa', '#ffcc33', '#83e070',
    '#fafa37', '#5986b3', '#8c78f0', '#ff6a4d', '#f078f0', '#2a7dd1',
    '#b25050', '#cc3366', '#cc9933', '#aaf0d1', '#ff00cc', '#3df53d',
    '#fa32b7', '#fa7dbb', '#ff355e', '#f59331', '#3d3df5', '#733380',
  ];

  export const BASE_STROKE_WIDTH = 1.75;